const words = [
  'Entrepreneurship',
  'Education',
  'Culture',
  'Innovation',
  'Leadership',
  'Collaboration',
]

const reasons = [
  'Proven Impact',
  'Global Network',
  'Trusted Partners',
  'Real Opportunity',
  'Lasting Change',
  'Community First',
]

export const wordTrack = [...words, ...words]
export const reasonTrack = [...reasons, ...reasons]
